import { Button } from 'src/v2/commonComponents/Button';
import { Waveform } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { useState } from 'react';
import { useDownloadFileTool, useGetUser } from 'src/hooks';
import { ConversionTargetType, Message } from 'src/types';
import { SpinnerSimple } from 'src/v2/commonComponents/SpinnerSimple';
import { toast } from 'react-toastify';
import { useChatHistory } from 'src/hooks';

type DownloadPodcastButtonProps = {
  activeTab?: string;
  message: Message;
  disabled: boolean;
};

export const DownloadPodcastButton = ({
  message,
  activeTab,
  disabled,
}: DownloadPodcastButtonProps) => {
  const { isNinjaRetired } = useChatHistory();
  const [isGenerating, setIsGenerating] = useState<boolean>(false);

  const { isOpenTier } = useGetUser();

  const { onDownload } = useDownloadFileTool({
    message,
    activeTab: activeTab || '',
  });

  const handleSuccess = () => {
    setIsGenerating(false);
    toast.success('Podcast downloaded to your device');
  };

  const handleClick = async () => {
    await onDownload({
      fileType: ConversionTargetType.PODCAST,
      onStart: () => setIsGenerating(true),
      onSuccess: handleSuccess,
      onFail: () => setIsGenerating(false),
    });
  };

  if (isNinjaRetired) {
    return null;
  }

  if (!activeTab) {
    return null;
  }

  return (
    <Button
      id="download-podcast-button"
      color="secondary-outline"
      tooltipContent={
        !isGenerating
          ? 'Generate and download podcast as an .mp3 file'
          : undefined
      }
      onClick={handleClick}
      disabled={isOpenTier || isGenerating || disabled}
    >
      {!isGenerating ? (
        <>
          <Waveform size={SVG_SIZE_M} />
          Podcast
        </>
      ) : (
        <>
          <SpinnerSimple size={SVG_SIZE_M} />
          Generating...
        </>
      )}
    </Button>
  );
};
